import BusinessMenu from './BusinessMenu.jsx';

export {
  BusinessMenu
}


// WEBPACK FOOTER //
// ./components/layouts/business/menu/index.js